import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { getOrgRole, isEndUser } from './roles';

type EndUserDataVisRedirectProps = {
  children: React.ReactNode;
};

/**
 * FLEXO-6066: end users have a single consolidated page per entity. The
 * energy/economics data-vis routes do not exist for them — `site-energy` and
 * `site-economics` collapse into `/site/:id`, `community-energy` and
 * `community-economics` into `/community/:id`. A direct URL to a data-vis route
 * is redirected to the consolidated page. Staff (admin/supervisor) are
 * unaffected and keep the separate data-vis pages.
 */
export function EndUserDataVisRedirect({
  children,
}: EndUserDataVisRedirectProps) {
  const user = useSelector((state: any) => state.user);
  const { id } = useParams();
  const location = useLocation();
  const pathSegment = location.pathname.split('/')[1];

  if (isEndUser(getOrgRole(user)) && id) {
    if (pathSegment === 'site-energy' || pathSegment === 'site-economics') {
      return <Navigate to={`/site/${id}`} replace />;
    }
    if (
      pathSegment === 'community-energy' ||
      pathSegment === 'community-economics'
    ) {
      return <Navigate to={`/community/${id}`} replace />;
    }
  }

  return <>{children}</>;
}
